@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.partner-alimony.title' | apContent }}</div>
}

@if (showPartnerAlimonyAmount()) {
    <partner-alimony-amount></partner-alimony-amount>
}
